import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokTextComponent } from '../../app/content/modules/storyblok/components/storyblok-text/storyblok-text.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokTextComponent> = {
  title: 'Storyblok/Text',
  component: StoryblokTextComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok rich text block. Renders HTML body content with optional text sizing and styling.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokTextComponent>;

export const Default: Story = {
  args: {
    body: '<h2>Velkommen til Supervin</h2><p>Vi tilbyder et bredt udvalg af vine fra hele verden. Vores eksperter har håndplukket de bedste vine til dig.</p>',
    _uid: 'sb-text-1',
    component: 'text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-text')).toBeTruthy();
  },
};

export const WithRichContent: Story = {
  args: {
    body: `
      <h1>Bordeaux Guide 2024</h1>
      <p>Bordeaux er en af verdens mest <strong>berømte vinregioner</strong>. Her finder du alt fra dagligdags vine til de mest eftertragede årgange.</p>
      <h3>Populære appellationer</h3>
      <ul>
        <li>Margaux</li>
        <li>Pauillac</li>
        <li>Saint-Émilion</li>
        <li>Pomerol</li>
      </ul>
      <p><em>Tip: Prøv at kombinere en Bordeaux med oksekød eller lammebryst.</em></p>
    `,
    _uid: 'sb-text-2',
    component: 'text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-text')).toBeTruthy();
  },
};

export const SmallText: Story = {
  args: {
    body: '<p>Priserne er inkl. moms og ekskl. levering.</p>',
    textSize: 'small',
    _uid: 'sb-text-3',
    component: 'text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-text')).toBeTruthy();
  },
};

export const TransparentBackground: Story = {
  args: {
    body: '<p>Denne tekst har transparent baggrund.</p>',
    transparentBackground: true,
    _uid: 'sb-text-4',
    component: 'text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-text')).toBeTruthy();
  },
};
